export function formatarNomeArquivo(nome?: string | null): string {
  if (!nome) return ''

  const nomeSemSufixoTecnico = nome.replace(/_\d{8}_\d{6}(?=\.[^./]+$)/, '')
  const ultimaBarra = Math.max(
    nomeSemSufixoTecnico.lastIndexOf('/'),
    nomeSemSufixoTecnico.lastIndexOf('\\'),
  )
  const ultimoPonto = nomeSemSufixoTecnico.lastIndexOf('.')

  return ultimoPonto > ultimaBarra + 1
    ? nomeSemSufixoTecnico.slice(0, ultimoPonto)
    : nomeSemSufixoTecnico
}
